//@flow
import React, { useState } from 'react';
import './tooltip.scss';

type Props = {
  info: string,
  children: React.Node,
};

export default function Tooltip({ children, info }: Props) {
  const [tooltip, setTooltip] = useState(false);

  const showTooltip = () => setTooltip(true);
  const hideTooltip = () => setTooltip(false);
  const toggleTooltip = () => setTooltip(!tooltip);

  return (
    <div
      onMouseEnter={showTooltip}
      onMouseLeave={hideTooltip}
      onClick={toggleTooltip}
      className={`tooltips ${tooltip ? 'active' : ''}`}
    >
      {children}

      {tooltip && (
        <div className="tooltips-info">
          <p>{info}</p>
        </div>
      )}
    </div>
  );
}
